// import TenUpAccordion from '../utilities/tenup-accordion-custom';
// const TenUp = window.TenUp;

/**
 * Fallback for css object-fit declaration
 * uses data attribute value 'data-fallback-img' to place background image on parent
 *
 * @return {void}
 */
const init = () => {
	TenUp.accordion( {
		target: '#spirit-shell-main', // ID (or class) of accordion container
	}, function() {
		// callback
	} );
};

export default {init};
